var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.14258C14.4734 7.14258 14.8571 7.52633 14.8571 7.99972C14.8571 8.43929 14.5262 8.80158 14.0999 8.8511L14 8.85686H1.99997C1.52658 8.85686 1.14282 8.47311 1.14282 7.99972C1.14282 7.56015 1.47371 7.19786 1.9 7.14834L1.99997 7.14258H14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39387 1.39363C7.72861 1.05889 8.27132 1.05889 8.60606 1.39363C8.91504 1.70262 8.93881 2.18881 8.67736 2.52506L8.60606 2.60581L3.21282 7.99972L8.60606 13.3936C8.91504 13.7026 8.93881 14.1888 8.67736 14.5251L8.60606 14.6058C8.29707 14.9148 7.81087 14.9386 7.47462 14.6771L7.39387 14.6058L1.39387 8.60581C1.08489 8.29683 1.06112 7.81063 1.32257 7.47438L1.39387 7.39363L7.39387 1.39363Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackWhite);
export default __webpack_public_path__ + "static/media/arrow-back-white.2baf686d6902843a12528af8b8a46619.svg";
export { ForwardRef as ReactComponent };